export default "__VITE_ASSET__CXA_VFQQ__"